import React from "react";

const ReportColumns = (taxName,tax) => {
  return [
    {
      title: "PRODUKT",
      width: "18%",
      key: "name",
      dataIndex: "name"
    },
    {
      title: "Antall",
      width: "15%",
      key: "quantity",
      dataIndex: "quantity"
    },
    {
      title: `Moms ${tax}%`,
      width: "20%",
      key: "moms25",
      render: (text, record) => {
        return `Kr.${(
          parseFloat(record.price) -
          parseFloat(record.price) / parseFloat(((100+Number(tax))/100))
        ).toFixed(2)}`;
      }
    },
    {
      title: "Nett Sum(Kr.)",
      width: "20%",
      key: "netsum",
      render: (text, record) => {
        return `Kr.${(
          parseFloat(record.price) -
          (parseFloat(record.price) -
            parseFloat(record.price) / parseFloat(((100+Number(tax))/100)))
        ).toFixed(2)}`;
      }
    },
    {
      title: `Totall(Kr.) - Rabatt(${taxName})`,
      width: "30%",
      key: "Totall",
      render: (text, record) => {
        return `Kr.${record.price.toFixed(2)}`;
      }
    }
  ];
};
const summaryColumns = (totalQuantity, total, discountPrice,tax) => {
  return [
    {
      title: "Navn",
      width: "18%",
      render: () => <strong>Total</strong>
    },
    {
      title: "Totall Antall",
      width: "15%",
      render: () => `${totalQuantity}`
    },
    {
      title: "Totall Moms",
      width: "20%",
      render: () =>
        `Kr.${(
          Number(total) -
          Number(discountPrice) -
          (Number(total) - Number(discountPrice)) / parseFloat(((100+Number(tax))/100))
        ).toFixed(2)}`
    },
    {
      title: "Nett Totall",
      width: "20%",

      render: () =>
        `Kr.${((Number(total) - Number(discountPrice)) / parseFloat(((100+Number(tax))/100))).toFixed(
          2
        )}`
    },
    {
      title: "Totall",
      width: "30%",
      render: () =>
        `Kr.${total && (Number(total) - Number(discountPrice)).toFixed(2)}`
    }
  ];
};
const summaryData = () => {
  return [
    {
      key: "-1",
      render: () => "test"
    }
  ];
};
const groupeDiscountColumn = () => {
  return [
    {
      title: "Faktura Nr.",
      width: "20%",
      key: "invoiceNumber",
      dataIndex: "invoiceNumber"
    },
    {
      title: "Rabatt(%)",
      width: "20%",
      key: "discount",
      dataIndex: "discount"
    },
    {
      title: "Rabatt Pris",
      width: "20%",
      key: "discountPrice",
      render: (text, record) => {
        return `${record.discountPrice.toFixed(2)}`;
      }
    }
  ];
};
const discountSummary = (discountPrice) => {
  return [
    {
      title: "Totall",
      width: "20%",
      key: "1",
      render: () => <strong>Totall</strong>
    },
    {
      title: "",
      width: "20%",
      key: "2"
    },
    {
      title: "Rabatt Pris",
      width: "20%",
      key: "discountPriceTotal",
      render: () => `${discountPrice.toFixed(2)}`
    }
  ];
};
const driveoutColumns = () => {
  return [
    {
      title: "Totall Ordre",
      dataIndex: "dcount",
      width: "10%",
      key: "dcount"
    },
    {
      title: "Utkjøring Moms",
      dataIndex: "driveoutTax",
      width: "10%",
      key: "driveoutTax"
    },
    {
      title: "Utkjøring Pris",
      dataIndex: "driveoutCharge",
      width: "15%",
      key: "driveoutCharge"
    },

    {
      title: "Totall Utkjøring Pris",
      dataIndex: "totalDcharge",
      width: "13%",
      key: "totalDcharge"
    }
  ];
};
const driveoutDataSource = ({
  driveoutTax,
  driveoutCharge,
  totalDcharge,
  count
}) => {
  return [
    {
      key: "1",
      dcount: count,
      driveoutTax: `Kr. ${driveoutTax}`,
      driveoutCharge: `Kr. ${driveoutCharge}`,
      totalDcharge: `Kr. ${totalDcharge}`
    }
  ];
};

const unpaidDataColumns = () => {
  return [
    {
      title: "Faktura Nr.",
      width: "45%",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber"
    },
    {
      title: "Totall",
      width: "45%",
      dataIndex: "taxPrice",
      key: "taxPrice"
    }
  ];
};
const unpaidSummaryColumns = (totalUnpaid) => {
  return [
    {
      title: "Navn",
      width: "45%",
      render: () => <strong>Totall</strong>
    },
    {
      title: "Totall",
      width: "45%",
      render: () => `Kr.${totalUnpaid.toFixed(2)}`
    }
  ];
};
const employeesTipColumn = () => {
  return [
    {
      title: "Navn",
      width: "20%",
      key: "firstName",
      dataIndex: "firstName",
      render: (text, record) => {
        return `${record.firstName}`;
      }
    },
    {
      title: "Email",
      width: "20%",
      key: "email",
      dataIndex: "email"
    },
    {
      title: "Cash",
      width: "20%",
      key: "cash",
      dataIndex: "cash",
      render: (text, record) => `Kr.${record.cash.toFixed(2)}`
    },
    {
      title: "Bank",
      width: "20%",
      key: "bank",
      dataIndex: "bank",
      render: (text, record) => `Kr.${record.bank.toFixed(2)}`
    },
    {
      title: "Total",
      width: "30%",
      key: "total",
      dataIndex: "total",
      render: (text, record) => `Kr.${record.total.toFixed(2)}`
    }
  ];
};
const tipSummaryColumns = (tipTotal) => {
  return [
    {
      title: "Name",
      width: "20%",
      render: () => <strong>Totall</strong>
    },
    {
      title: "email",
      width: "20%",
      render: () => <strong> </strong>
    },
    {
      title: "cash",
      width: "20%",
      render: () => <strong> </strong>
    },
    {
      title: "bank",
      width: "20%",
      render: () => <strong> </strong>
    },
    {
      title: "Totall",
      width: "30%",
      render: () => `Kr.${tipTotal}`
    }
  ];
};
export {
  ReportColumns,
  summaryColumns,
  summaryData,
  groupeDiscountColumn,
  discountSummary,
  driveoutColumns,
  driveoutDataSource,
  unpaidDataColumns,
  unpaidSummaryColumns,
  employeesTipColumn,
  tipSummaryColumns
};
